{
  "intro": "TLS certificates for the HTTPS services of load balancers: your own, uploaded with its private key, or managed — the provider gets one from Let's Encrypt for your domains and renews it.",
  "empty": "No certificates yet",
  "emptyLead": "An HTTPS service of a load balancer needs a certificate for its domains. Let one be issued and renewed for you, or upload your own.",
  "create": "Add certificate",
  "createLead": "Managed is the easy way; upload your own when you already have one.",
  "kind": "Kind",
  "kinds": {
    "managed": "Managed (Let's Encrypt)",
    "uploaded": "Uploaded"
  },
  "kindHints": {
    "managed": "Issued and renewed automatically for the domains you name. Their DNS zones must be hosted in Hetzner DNS.",
    "uploaded": "Your own certificate and private key in PEM form. You renew it yourself before it expires."
  },
  "name": "Name",
  "nameHint": "To recognise it when choosing a certificate for a service.",
  "domains": "Domains",
  "domainsHint": "One per line; *.example.com covers the subdomains one level down.",
  "domainsInvalid": "Name at least one domain such as example.com. Not a domain: {{domain}}",
  "managedDnsNote": "The provider proves the domains through DNS: their zones must be hosted in Hetzner DNS, or issuing fails. It can take a few minutes.",
  "certificate": "Certificate (PEM)",
  "certificateHint": "Your certificate first, then the intermediate certificates.",
  "pemInvalid": "Paste the certificate in PEM form, starting with -----BEGIN CERTIFICATE-----.",
  "privateKey": "Private key (PEM)",
  "privateKeyHint": "Goes straight to the provider. CloudServer does not keep it, show it again or write it to logs.",
  "keyInvalid": "Paste the private key in PEM form, starting with -----BEGIN PRIVATE KEY-----.",
  "requestSubmit": "Request certificate",
  "uploadSubmit": "Upload certificate",
  "requested": "Certificate {{name}} requested; issuing takes a few minutes",
  "uploaded": "Certificate {{name}} uploaded",
  "labels": "Labels",
  "edit": "Name and labels",
  "editTitle": "Certificate {{name}}",
  "retry": "Retry issuing",
  "retrying": "Trying to issue {{name}} again…",
  "stateTitle": "State",
  "state": {
    "pending": "Being issued",
    "failed": "Issuing failed",
    "renewalFailed": "Renewal failed",
    "expired": "Expired",
    "soon": "Expires soon",
    "valid": "Valid",
    "unknown": "Unknown"
  },
  "expires": "Valid until",
  "usedBy": "Used by",
  "unused": "Not used",
  "createdAt": "Added",
  "why": {
    "inUse": "A load balancer uses it; remove it from its HTTPS services first",
    "notFailed": "Only a failed issuing or renewal can be retried"
  },
  "delete": "Delete certificate",
  "deleteTitle": "Delete certificate {{name}}?",
  "deleteGone": "It cannot be chosen for HTTPS services any more.",
  "deleteKey": "The provider deletes its private key too; to use it again, upload it again.",
  "deleted": "Certificate {{name}} deleted"
}
